var ButtonTheme;
(function (ButtonTheme) {
    ButtonTheme["ACCENT"] = "accent";
    /** @deprecated This member is deprecated in favor of {@link ButtonTheme.PRIMARY} and is no longer supported. */
    ButtonTheme["DEFAULT"] = "default";
    ButtonTheme["OUTLINE"] = "outline";
    ButtonTheme["PRIMARY"] = "primary";
    ButtonTheme["QUIET_DEFAULT"] = "quiet-default";
    ButtonTheme["QUIET_EMPHASIS"] = "quiet-emphasis";
    ButtonTheme["SECONDARY"] = "secondary";
})(ButtonTheme || (ButtonTheme = {}));
export default ButtonTheme;
//# sourceMappingURL=button-theme.js.map